import * as actions from "./actions";
import { Record, Map, fromJS } from "immutable";

import MenuItems from "./menuItems.js";

const InitialState = Record({
  menuItems: MenuItems
});
const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function menuReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  switch (action.type) {
    case actions.SET_IS_DROPDOWN_OPEN: {
      return state.setIn(
        ["menuItems"].concat(action.payload.parents).concat("height"),
        action.payload.height
      );
    }

    case actions.ADD_MENU_ITEMS: {
      return state.setIn(
        ["menuItems"].concat(action.payload.path),
        action.payload.menuItems
      );
    }

  }
  return state;
}



// WEBPACK FOOTER //
// ./src/common/menu/reducer.js